import { MakeCall } from './createMakeCall';

const getPayoutMethod = (makeCall: MakeCall) => (methodId: number) =>
  makeCall<undefined>('GET', `/api/v2/user/me/payout-method/${methodId}`);
export { getPayoutMethod };
